import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor from "vuelidate-error-extractor";
import FormGroup from '@/components/templates/FormGroup';
import MultiError from '@/components/templates/MultiError';
import VueLogger from 'vuejs-logger';
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueTheMask from 'vue-the-mask'

import VueKeyCloak from '@/plugins/keycloak-plugin';
import Axios from '@/plugins/axios-plugin';
import { store } from './store/store'
import VueBrowserUpdate from "@sum.cumo/vue-browserupdate";
import Es6Promise from 'es6-promise'
import ConfigService from "./services/ConfigService";
Es6Promise.polyfill()

Vue.use(VueBrowserUpdate, {
  options: {
    required:{
      e:16,
      i:12,
      f:58,
      o:51,
      o_a:45,
      s:-1,
      c:"67.0.3396.12",
      y:18.1,
      v:"1.10",
      uc:11.5,
      samsung:7.0
    }}
});

Vue.config.productionTip = false
Vue.use(Vuelidate)

Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  template: FormGroup,
  messages: {
    required: "{attribute} is required.",
    email: "{attribute} is not a valid Email Address.",
    numeric: "{attribute} must be a numeric value.",
    requiredIf: "{attribute} is required.",
    url: "{attribute} is not a valid URL.",
    fileType: "File must be a valid file type: .pdf, .docx, or .png.",
    maxFileSize: "File is too large.",
    minLength: "{attribute} has not met required minimum length.",
    maxLength: "{attribute} is too long.",
    minValue: "{attribute} minimum is $1.00.",
    decimal: "{attribute} must be a valid decimal number.",
    isMoneyDecimal: "{attribute} must be a valid money amount."
  },
});

Vue.component('form-summary', MultiError)

const options = {
  isEnabled: true,
  logLevel : Vue.config.productionTip  ? 'error' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(Axios);
Vue.use(VueTheMask);

ConfigService.setConfigs().then(a => {
    Vue.use(VueKeyCloak, {
        init: {
            onLoad: 'check-sso',
            checkLoginIframe: false
        },
        config: {
            url: ConfigService.getAuthUrl(),
            clientId: ConfigService.getUiClientName(),
            realm: ConfigService.getRealmName(),
            logoutRedirectUri: ConfigService.getLogoutUrl()
        },
        onReady: kc => {
            new Vue({
                router,
                store,
                render: h => h(App)
            }).$mount('#app')
        }
    })
})

const requireComponent = require.context(
    './components/templates/input',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
      camelCase(
          fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
      )
  )

  Vue.component(
      componentName,
      componentConfig.default || componentConfig
  )
})